import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import swal from 'sweetalert';
import shortid from 'shortid';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';
import { fetchQueryData } from '../../../utils/sf-request';

export default null;
// Columns for list

export function terminationColumns() {
    return [{
        Header: 'Termination No',
        accessor: 'Name',
    }, {
        Header: 'Beneficiary Name',
        accessor: 'Terminating_Beneficary__r',
        Cell: columnProps => (columnProps.value ? columnProps.value.Name : ''),
        filterMethod: (filter, row) => {
            if (row.Terminating_Beneficary__r) {
                if (row.Terminating_Beneficary__r.Name.toLowerCase().includes(filter.value.toLowerCase())) {
                    return row;
                }
            }
        },
        sortMethod: (a, b) => {
            if (a === null) a = { Name: '' };
            if (b === null) b = { Name: '' };
            if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
                return 1;
            } else if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
                return -1;
            }

            return 0;
        },
    }, {
        accessor: 'Reason_for_Termination__c',
        Header: 'Termination Reason',
    }, {
        accessor: 'Termination_Status__c',
        Header: 'Termination Status',
    }, {
        accessor: 'Termination_Date__c',
        Header: 'Termination Date',
        Cell: columnProps => moment(columnProps.value).format('DD MMM YYYY'),
        filterMethod: (filter, row) => {
            if (moment(row.Termination_Date__c).format('DD MMM YYYY').toLowerCase().indexOf(filter.value.toLowerCase()) !== -1) return row;
        },
    }, {
        Header: 'Action',
        accessor: 'Id',
        filterable: false,
        sortable: false,
        Cell: (columnProps) => {
            const buttons = [];
            const terminationStatus = columnProps.original.Termination_Status__c;
            const authority = this.props.user.loggedInUser.Partner_Authority__c;
            const { Partner_Type__c } = this.props.user.loggedInUser.Account;
            const isActive = columnProps.original.Terminating_Beneficary__r ? columnProps.original.Terminating_Beneficary__r.Active__c : false;
            if (isActive) {
                if (terminationStatus.toLowerCase() === 'planned') {
                    const form = {
                        Termination_Status__c: columnProps.original.Termination_Status__c,
                        Name: columnProps.original.Name,
                        Reason_for_Termination__c: columnProps.original.Reason_for_Termination__c,
                        Id: columnProps.original.Id,
                        Termination_Date__c: moment(columnProps.original.Termination_Date__c),
                        Terminating_Beneficary__c: columnProps.original.Terminating_Beneficary__c,
                        beneficiaryName: columnProps.original.Terminating_Beneficary__r.Name,
                    };
                    buttons.push(
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={() => this.setState({ editMode: true, showModal: true, form })}
                            key={shortid.generate()}
                        >
                            <i className="fa fa-edit" />Edit
                        </button>,
                        <button
                            className="btn btn-info btn-fill btn-sm"
                            onClick={() => this.updateTerminationStatus(columnProps.value, 'Verified by Partner')}
                            key={shortid.generate()}
                        >
                            <i className="fa fa-check" />Verify
                        </button>,
                    );
                } else if (terminationStatus === 'Verified by Partner' && authority.toLowerCase() === 'approver') {
                    buttons.push(
                        <button
                            onClick={() => this.updateTerminationStatus(columnProps.value, 'Approved by Partner')}
                            className="btn btn-success btn-sm"
                            key={shortid.generate()}
                        >
                            <i className="fa fa-thumbs-up" /> Approve
                        </button>
                    );

                    buttons.push(
                        <button
                            onClick={() => this.updateTerminationStatus(columnProps.value, 'Rejected by Partner')}
                            className="btn btn-danger btn-sm"
                            key={shortid.generate()}
                        >
                            <i className="fa fa-thumbs-down" /> Reject
                        </button>
                    );
                } else if (terminationStatus === 'Approved by Partner' && Partner_Type__c !== 'Disbursing Agency') {
                    buttons.push(
                        <button
                            onClick={() => this.updateTerminationStatus(columnProps.value, 'Submitted to SPMF')}
                            className="btn btn-default btn-fill btn-sm"
                            key={shortid.generate()}
                        >
                            <i className="fa fa-paper-plane" /> Submit To SPMF
                        </button>
                    );
                }
            }
            return (
                <div className="btn-group" role="group" aria-label="...">
                    {buttons}
                </div>
            );
        },
    }];
}

export const PersonColumn = [{
    Header: 'Beneficiary Name',
    accessor: 'Name',
}, {
    accessor: 'ID_Number__c',
    Header: 'Id Number',
}, {
    accessor: 'Total_Amount_Received__c',
    Header: 'Total Amount Received',
    Cell: columnProps => (
        <span>{columnProps.value ? columnProps.value.toLocaleString() : 0}</span>
    ),
}];

export const ReceiptContactColumn = [{
    id: 'Name',
    Header: 'Beneficiary Name',
    accessor: 'Beneficiary__r',
    Cell: columnProps => columnProps.value.Name,
}, {
    id: 'ID_Number__c',
    accessor: 'Beneficiary__r',
    Header: 'Id Number',
    Cell: columnProps => columnProps.value.ID_Number__c,
}, {
    id: 'Total_Amount_Received__c',
    accessor: 'Beneficiary__r',
    Header: 'Total Amount Received',
    Cell: columnProps => columnProps.value.Total_Amount_Received__c,
}, {
    id: 'Status__c',
    accessor: 'Status__c',
    Header: 'Status Receipt',
    Cell: columnProps => columnProps.value,
}];

/**
* this need to bind with main component
*/
export function getTerminationList() {
    const query = `Select Id, Name, Reason_for_Termination__c, Termination_Status__c, Terminating_Beneficary__r.Active__c,
        Terminating_Beneficary__r.Name, Termination_Date__c, Terminating_Beneficary__c from Termination__c where
        Terminated_by_Partner__c = '${this.props.user.loggedInUser.AccountId}'
        Order By Termination_Status__c, LastModifiedDate DESC`;

    return fetchQueryData(query, this.props.user.siteToken.hash, this.props.user.key);
}
/**
 * this need to bind with main component
 */
export async function createTermination() {
    if (this.state.loading) return;
    const {
        Id,
        Reason_for_Termination__c,
        Termination_Status__c,
        Terminating_Beneficary__c,
        Termination_Date__c,
    } = this.state.form;

    this.setState({ loading: true });
    try {
        if (Reason_for_Termination__c.trim() === '' || Terminating_Beneficary__c.trim() === '') {
            throw new Error('Termination reason and beneficiary name must not be empty');
        }

        const formValue = {
            Reason_for_Termination__c,
            Termination_Status__c,
            Terminating_Beneficary__c,
            Termination_Date__c: Termination_Date__c.format('YYYY-MM-DD'),
            Terminated_by_Partner__c: this.props.user.loggedInUser.AccountId,
        };
        if (this.state.editMode) {
            formValue.Id = Id;
            delete formValue.Terminated_by_Partner__c;
        }
        // console.log(formValue.Termination_Date__c.format('YYYY-MM-DD'))
        const result = await fetch(`${spmfcloudFunctionUrl}/create-termination`, {
            mode: 'cors',
            cache: 'no-cache',
            method: this.state.editMode ? 'PATCH' : 'POST',
            body: JSON.stringify(formValue),
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            const json = await response.json();
            if (!response.ok) throw new Error(json.message);
            return json;
        });

        // Refreshing the termination list
        const data = await this.getTerminationList();

        this.setState({
            loading: false,
            showModal: false,
            form: {},
            data: data.records || [],
        });

        swal({
            text: result.message,
            title: 'Create termination record success.',
        });
    } catch (error) {
        swal({
            text: error.message,
            title: 'Error when creating termination record',
            dangerMode: true,
        });
        this.setState({ loading: false });
    }
}
/**
 * Update a record to salesforce, need to be bind with main component
 * @param {*} id : Termination ID
 * @param {*} status : Status that want to inserted
 */
export async function updateTerminationStatus(id, status) {
    if (this.state.loading) return;
    this.setState({ loading: true });
    try {
        const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Termination__c`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'PATCH',
            body: JSON.stringify({
                Id: id,
                Termination_Status__c: status,
            }),
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            if (response.status !== 200) throw (new Error(response.message));
            return response.json();
        });
        await this.componentWillMount(true);
        this.setState({ loading: false });
        console.log(result);
        swal({
            text: result.message,
            title: 'Termination status updated successfully.',
        });
    } catch (error) {
        swal({
            text: error.toString(),
            title: 'An error occured when updating status',
        });
        this.setState({ loading: true });
    }
}
/**
 * Deleting termination must be binded with main component
 * @param {*} id : Termination ID
 */
export async function deleteTermination(id) {
    if (this.state.loading) return;
    this.setState({ loading: true });
    try {
        const result = await fetch(`${spmfcloudFunctionUrl}/termination/${id}`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'DELETE',
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            if (response.status !== 200) throw (new Error(response.message));
            return response.json();
        });
        await this.componentWillMount();
        this.setState({ loading: false });
        swal({
            text: result.message,
            title: 'Termination status deleted successfully.',
        });
    } catch (error) {
        swal({
            text: error.toString(),
            title: 'Fail when deleting termination object.',
            dangerMode: true,
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Termination/actions.js
// module id = 198
// module chunks = 0